var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div dias-cloak=\"vm.loading\"><div ng-if=\"vm.dashboardShowStatus\" vueinit><dashboard-private></dashboard-private></div><div ng-if=\"vm.wizardShowStatus\" vueinit><vue-dashboard-wizard-antragsteller></vue-dashboard-wizard-antragsteller></div><div ng-if=\"vm.dashboardPublicShowStatus\" vueinit><dashboard-public></dashboard-public></div></div>");;return buf.join("");
}